// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2-qMl","content":"RecentSearches_content__1kt9E"};